module.exports = __webpack_public_path__ + "static/media/org2.8a00272e.png";